import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {useBbox, useComponentProps} from 'helpers/hooks/utils';
import CollectionProfile from 'components/organisms/Profiles/CollectionProfile/CollectionProfile';
import Box from 'components/atoms/Layout/Box/Box';
import StyledServicesSettingPage from 'components/pages/Setting/ServicesSettingPage/ServicesSettingPage.styles';
import {useAuthorize} from 'components/organisms/Providers/AuthProvider/AuthProvider';
import {useProfile} from 'components/organisms/Providers/ProfileProvider/ProfileProvider';
import SettingsHeaderWrapper from 'components/templates/Wrappers/Settings/SettingsHeaderWrapper/SettingsHeaderWrapper';
import useMediaQuery from '@mui/material/useMediaQuery';

const info = 'Select services that you would like to apply on specific collections, or by default on all companies or on companies that have a deal flow status';

const ServicesSettingPage = (props) => {
  const innerProps = useComponentProps(props, 'ServicesSettingPage');

  const contentRef = useRef(null);

  const profileProvider = useProfile();
  const authorize = useAuthorize();

  const bBox = useBbox(() => contentRef.current, ['width']);

  const smDown = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const handleShowCard = (card) => {
    return card.name.startsWith('service');
  };

  const handleCanUpdate = () => {
    return authorize({attribute: 'settings.services.update'});
  }

  const handleDirty = (dirty) => {
    profileProvider.dirty?.(dirty);
  }

  const columns = bBox?.width ? Math.max(Math.floor((bBox?.width ?? 0) / 232), 1) : 0;

  return <StyledServicesSettingPage as={SettingsHeaderWrapper} {...innerProps}
                                    title="Services"
                                    info={!smDown ? info : null}>
    <Box ref={contentRef} className="ServicesSettingPage-content">
      <CollectionProfile columns={columns}
                         variant="grid"
                         onShowCard={handleShowCard}
                         onDirty={handleDirty}
                         onCanUpdate={handleCanUpdate}/>
    </Box>
  </StyledServicesSettingPage>
};

ServicesSettingPage.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default ServicesSettingPage;
